import React, { useState, useEffect } from 'react';

import { ApolloConsumer } from 'react-apollo';
import { Drawer, DrawerGridList } from '../../../ui-kit';
import { UploaderConsumer } from '../../Uploader';
import RequestProvider from '../../RequestProvider';
import { AuthorisationConsumer } from '../../AuthorisationWrapper';
import AssetLibraryComponent from '../components/AssetLibrary';
import { NoThumbnailImage } from '../../../assets/images';
import StockAssetLibraryComponent from '../components/StockAssetLibrary';
import { withFlagsConsumer } from '../../FeatureFlags';

import {
  getAssetSummariesAndCountQuery,
  getUsersQuery,
  deleteAssetApi,
  searchStockAssetsQuery,
  createOrgStockAssetsQuery,
  getFilteredVideosQuery,
  updateVideoAtomicQuery,
  getTagCountsForOrganisationQuery,
  createAssetTagApi,
  updateAssetTagApi,
  deleteAssetTagApi,
  tagAssetResourceApi,
  untagAssetResourceApi } from
'../queries';
















function AssetLibrary({
  history,
  showActiveFilter,
  showSortingDropdown,
  listProps,
  isStockLibrary,
  selectedAssets,
  isListEditable,
  withBulkActions,
  flags,
  bulkSelect = true,
  filterByAssetType
}) {
  const [selectedDrawerItems, setSelectedDrawerItems] = useState([]);
  const [selectedDrawerItemIds, setSelectedDrawerItemIds] = useState([]);
  const [showGridList, setShowGridList] = useState(true);
  const [isProjectBrief, setIsProjectBrief] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [triggerOpen, setTriggerOpen] = useState(false);
  const [libraryTypeStock, setLibraryTypeStock] = useState(false);
  const { showShutterstockAssets = false, enableAdobeStock = false } = flags || {};

  useEffect(() => {
    // Determines if project brief relevant params are in url.
    // Applies when the user navigates to the media library from a project brief.
    // If true, feature toggles project brief related UI such as the side drawer, etc.
    // If false, the media library is in its normal state.
    const urlParams = new URLSearchParams(window.location.search);
    const isStockParam = urlParams.get('stock');
    const sourcingAssetsParam = urlParams.get('sourcingassets');
    if (sourcingAssetsParam) setIsProjectBrief(true);
    if (isStockLibrary) setLibraryTypeStock(true);
    if (isStockParam) setLibraryTypeStock(isStockParam === 'true');
  }, []);

  useEffect(() => {
    setLibraryTypeStock(isStockLibrary);
  }, [isStockLibrary]);


  const removeGridListItem = (itemId) => {
    // Project Brief logic
    const tempListItems = selectedDrawerItems;
    const selectedIndex = tempListItems.findIndex((e) => e.id === itemId);
    let tempIds = selectedDrawerItemIds;
    if (selectedIndex > -1) {
      tempListItems.splice(selectedIndex, 1);
      tempIds = tempIds.filter((e) => e !== itemId);
    }
    setSelectedDrawerItems(tempListItems);
    setSelectedDrawerItemIds(tempIds);
    setShowGridList(true);
    selectedAssets(tempListItems);
  };

  const addGridListItem = async (item) => {
    // Project Brief logic
    const { id, checkedState } = item;
    const isSelected = selectedDrawerItemIds.includes(id);
    if (isSelected && checkedState) return;
    await setShowGridList(false);
    if (checkedState) {
      let tempListItems = selectedDrawerItems;
      let tempIds = selectedDrawerItemIds;

      if (bulkSelect) {
        tempListItems.push(item);
        tempIds.push(id);
      } else {
        tempListItems = [item];
        tempIds = [id];
      }
      setSelectedDrawerItems(tempListItems);
      setSelectedDrawerItemIds(tempIds);
      setShowGridList(true);
      selectedAssets(tempListItems);
      setDrawerOpen(true);
      setTriggerOpen(true);
    } else {
      removeGridListItem(id);
      setDrawerOpen(true);
    }
  };

  const onCheckboxNonStockItem = async (item) => {
    // Project Brief logic
    const { id, checkedState, thumbnail, assetType } = item;
    const selectedAsset = {
      id,
      assetOrigin: 'library',
      checkedState,
      name: 'Library Asset',
      assetType,
      typeIcon: assetType,
      thumbnailUrl: thumbnail || NoThumbnailImage
    };
    addGridListItem(selectedAsset);
  };

  const handleBulkSelectAssets = (assets) => {
    const transformedItems = assets.map((asset) => {
      const { assetId, assetFiles, metaData } = asset;
      const { THUMBNAIL, ORIGINAL } = assetFiles || {};
      let assetType = 'other';
      try {
        const meta = JSON.parse(metaData);
        if (meta && meta.type) {
          const [t] = meta.type.split('/');
          assetType = t;
        }
      } catch (e) {
        // ignore
      }
      return {
        id: assetId,
        assetOrigin: 'library',
        checkedState: true,
        name: 'Library Asset',
        assetType,
        typeIcon: assetType,
        thumbnailUrl: THUMBNAIL || ORIGINAL || NoThumbnailImage
      };
    });

    const transformedIds = transformedItems.map((item) => item.id);

    setSelectedDrawerItems(transformedItems);
    setSelectedDrawerItemIds(transformedIds);
    setShowGridList(true);
    // The Drawer JSX below renders only when `isProjectBrief && triggerOpen`.
    // Toggling drawerOpen outside the project-brief flow only applies the
    // .drawer-open width override (calc(100% - 375px)) without rendering a
    // Drawer — producing an empty 375px sidebar in the main media library.
    if (isProjectBrief) {
      setDrawerOpen(true);
      setTriggerOpen(true);
    }

    if (selectedAssets) {
      selectedAssets(transformedItems);
    }
  };

  const onToggleExpanded = (value) => {
    setDrawerOpen(value);
  };

  return (
    <ApolloConsumer>
      {(apolloClient) =>
      <AuthorisationConsumer>
          {({
          selectedOrganisation: {
            organisationId,
            name,
            permissions: orgPermissions,
            shutterstockAccess
          } }) =>
        <RequestProvider
          requests={{
            getAssetSummariesAndCount: getAssetSummariesAndCountQuery(organisationId),
            getTagCounts: getTagCountsForOrganisationQuery(organisationId),
            createAssetTag: createAssetTagApi(organisationId),
            updateAssetTag: updateAssetTagApi,
            deleteAssetTag: deleteAssetTagApi,
            tagAssetResource: tagAssetResourceApi,
            untagAssetResource: untagAssetResourceApi,
            getUsers: getUsersQuery(organisationId),
            deleteAsset: deleteAssetApi(),
            searchStockAssets: searchStockAssetsQuery(organisationId),
            createOrgStockAssets: createOrgStockAssetsQuery(organisationId),
            getFilteredVideos: getFilteredVideosQuery(organisationId),
            updateVideoAtomic: updateVideoAtomicQuery()
          }}>

                {({
            getAssetSummariesAndCount,
            getTagCounts,
            createAssetTag,
            updateAssetTag,
            deleteAssetTag,
            tagAssetResource,
            untagAssetResource,
            getUsers,
            deleteAsset,
            searchStockAssets,
            createOrgStockAssets,
            getFilteredVideos,
            updateVideoAtomic
          }) =>
          <UploaderConsumer>
                    {({ assetsMap, removeAsset, updateAssetLocally }) =>
            <>
                        {isProjectBrief && triggerOpen &&

              <>
                            <Drawer
                  isMinimised={!drawerOpen}
                  width={375}
                  align="right"
                  className="asset-library-drawer"
                  onToggleExpanded={onToggleExpanded}>

                              {showGridList &&

                  <DrawerGridList
                    headerTitle="Selected Assets"
                    listItems={selectedDrawerItems}
                    removeItem={(itemId) => removeGridListItem(itemId)}
                    emptyListContent={{
                      heading: 'No assets have been selected',
                      text: 'Add assets from your media library and upload them to your Project Brief'
                    }} />}



                            </Drawer>
                          </>}


                        {libraryTypeStock ?

              <StockAssetLibraryComponent
                shutterstockAccess={shutterstockAccess && libraryTypeStock}
                searchStockAssets={searchStockAssets}
                createOrgStockAssets={createOrgStockAssets}
                getFilteredVideos={getFilteredVideos}
                history={history}
                apolloClient={apolloClient}
                organisationId={organisationId}
                organisationName={name}
                updateVideoAtomic={updateVideoAtomic}
                showActiveFilter={showActiveFilter}
                selectedDrawerItemIds={selectedDrawerItemIds}
                addGridListItem={(item) => addGridListItem(item)}
                isProjectBrief={isProjectBrief}
                isShutterStockUnlimited={shutterstockAccess && showShutterstockAssets}
                enableAdobeStock={enableAdobeStock}
                showShutterstockAssets={showShutterstockAssets}
                drawerOpen={drawerOpen} /> :


              <AssetLibraryComponent
                getAssetSummariesAndCount={getAssetSummariesAndCount}
                getTagCounts={getTagCounts}
                createAssetTag={createAssetTag}
                updateAssetTag={updateAssetTag}
                deleteAssetTag={deleteAssetTag}
                tagAssetResource={tagAssetResource}
                untagAssetResource={untagAssetResource}
                getUsers={getUsers}
                history={history}
                apolloClient={apolloClient}
                assetsMap={assetsMap}
                organisationId={organisationId}
                removeFromAssetsMap={removeAsset}
                updateInAssetMap={updateAssetLocally}
                organisationName={name}
                deleteAsset={deleteAsset}
                orgPermissions={orgPermissions}
                listProps={listProps}
                showActiveFilter={showActiveFilter}
                showSortingDropdown={showSortingDropdown}
                isListEditable={isListEditable}
                withBulkActions={withBulkActions}
                selectedDrawerItemIds={selectedDrawerItemIds}
                isProjectBrief={isProjectBrief}
                handleAddToProjectBriefClick={(item) => onCheckboxNonStockItem(item)}
                onBulkSelectAssets={handleBulkSelectAssets}
                filterByAssetType={filterByAssetType}
                drawerOpen={drawerOpen} />}


                      </>}

                  </UploaderConsumer>}

              </RequestProvider>}

        </AuthorisationConsumer>}

    </ApolloConsumer>);

}

export default withFlagsConsumer(AssetLibrary);